var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiPoll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 23",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.333,
    y: 0.667,
    width: 14,
    height: 8.667,
    rx: 1,
    fill: "#A8FFF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6.667,
    width: 2.667,
    height: 10.531,
    rx: 1,
    fill: "#CBFF88"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9.333,
    width: 2.667,
    height: 7.864,
    rx: 1,
    fill: "#CBFF88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M10.333 5.333h12v8h-12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.333 3.418c.154 0 .278.13.278.29v9.003c0 .16-.124.289-.278.289H13.667a.283.283 0 01-.278-.289V3.707c0-.16.124-.289.278-.289h10.666zm-10.389 9.005h10.112V3.995H13.944v8.426z",
    fill: "#14454C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.389 3.13c.153 0 .278.13.278.288 0 .16-.125.29-.278.29H12.61a.283.283 0 01-.278-.29c0-.159.125-.288.278-.288h12.778zM16.889 11.037c0 .16-.125.29-.278.29a.283.283 0 01-.278-.29V8.151c0-.159.125-.288.278-.288.153 0 .278.13.278.288v2.886zM18.889 11.037c0 .16-.125.289-.278.289a.283.283 0 01-.278-.289V5.381c0-.16.125-.289.278-.289.153 0 .278.13.278.289v5.656zM19.217 12.891l-2.667 3.464a.271.271 0 01-.39.045.296.296 0 01-.044-.406l2.667-3.463a.27.27 0 01.39-.045c.12.1.14.28.044.405z",
    fill: "#14454C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.783 12.891l2.667 3.464a.27.27 0 00.39.045c.12-.1.14-.281.044-.406l-2.667-3.463a.27.27 0 00-.39-.045c-.12.1-.14.28-.044.405zM20.889 11.038c0 .159-.125.288-.278.288a.283.283 0 01-.278-.288V6.766c0-.16.125-.288.278-.288.153 0 .278.129.278.288v4.272z",
    fill: "#14454C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 0l.99 2.51L38 3.5l-2.51.99L34.5 7l-.99-2.51L31 3.5l2.51-.99L34.5 0zM3.5 16l.99 2.51L7 19.5l-2.51.99L3.5 23l-.99-2.51L0 19.5l2.51-.99L3.5 16z",
    fill: "#14D1C2"
  })));
}
export default __webpack_public_path__ + "fonts/ai-poll-2426e09c1a97546546895a478035a6b6.svg";
export { SvgAiPoll as ReactComponent };